"use client"
import {Box, Grid} from "@mantine/core";
import {CategoryItem} from "src/features/client/category/ui/category-item";
import {Categories, searchCategories} from "src/entities/categories";
import {useEffect, useState} from "react";

export const CategoriesWidget = ({parentId}: {parentId?: number}) => {
    const [categories, setCategories] = useState<Categories[]>()

    const fetchCategories = async () => {
        const res = await searchCategories({
            filter: {},
            sorting: {sortBy: "ID", sortDirection: "DESC"},
            pageRequest: {limit: 100, page: 0}
        },false)
        if(parentId){
        setCategories(res?.content?.filter(el => el.parentId?.id === parentId))
        }else{
            setCategories((res?.content))
        }
    }
    useEffect(() => {
        fetchCategories()
    }, []);
    return (
        <Box bg="#FAFAFA" py={{base: 40, sm: 80}}>
            <Grid className="container" gutter={24}>
                {categories?.map((category) => !category?.parentId ? (
                    <Grid.Col key={category.id} span={{base: 12, sm: 6,md: 4, xl: 3}}>
                        <CategoryItem isParent={true}  data={category}/>
                    </Grid.Col>
                ) : null)}
            </Grid>
        </Box>
    )
}
